import {SaleTypeVo} from '../../../common/shared/api/nicolas/vo/SaleTypeVo.enum';
import {TicketSalesVo} from '../../../common/shared/api/nicolas/vo/TicketSalesVo.interface';
import {ExtraLabelType} from '../../../graphql/generated/types';

export function getTicketSalesRefundExtraLabel(
  ticketSales: TicketSalesVo
): ExtraLabelType | undefined {
  if (ticketSales.sale_type === SaleTypeVo.Refund) {
    return ExtraLabelType.RefundTicket;
  }
  return undefined;
}
